/* Bystorymum : interactions (s'appuie sur le tiroir panier natif de Dawn) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- Panier : ajout via l'API AJAX + tiroir Dawn ---------- */
  async function addToCart(variantId, qty = 1, trigger) {
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: Number(variantId), quantity: qty }] };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = window.location.pathname;
    }
    trigger && trigger.classList.add('is-loading');
    try {
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Ajout impossible.');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bsm', productVariantId: variantId, cartData: data });
      }
      if (drawer) {
        drawer.classList.remove('is-empty');
        const item = (data.items && data.items[0]) || {};
        drawer.renderContents({ ...data, id: item.id || variantId });
      } else {
        window.location.href = window.routes.cart_url;
      }
      return true;
    } catch (e) {
      return e.message;
    } finally {
      trigger && trigger.classList.remove('is-loading');
    }
  }

  /* Ajout rapide depuis les cartes */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-bsm-add]');
    if (!b) return;
    e.preventDefault();
    const r = await addToCart(b.dataset.bsmAdd, 1, b);
    if (r !== true) toast(r);
  });

  /* ---------- Toast ---------- */
  let toastEl, tt;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.style.cssText =
        'position:fixed;z-index:90;left:50%;bottom:24px;transform:translateX(-50%);background:#000;color:#EEEBE4;padding:12px 18px;font-size:14px;transition:opacity .25s;opacity:0;pointer-events:none;max-width:90vw';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.opacity = 1;
    clearTimeout(tt);
    tt = setTimeout(() => (toastEl.style.opacity = 0), 3200);
  }

  /* ---------- Menu mobile ---------- */
  const mnav = $('#bsm-mnav');
  const burger = $('[data-bsm-burger]');
  /* iOS Safari : le panneau ne doit pas vivre dans l'en-tête sticky, sinon les liens ne répondent pas au toucher */
  if (mnav && mnav.parentElement !== document.body) document.body.appendChild(mnav);
  mnav?.addEventListener('click', (e) => { if (e.target.closest('a[href]')) { mnav.classList.remove('is-open'); document.body.classList.remove('bsm-lock'); } });
  function openMnav() { if (!mnav) return; mnav.classList.add('is-open'); document.body.classList.add('bsm-lock'); burger?.setAttribute('aria-expanded', 'true'); $('[data-bsm-mnav-close]', mnav)?.focus(); }
  function closeMnav() { if (!mnav) return; mnav.classList.remove('is-open'); document.body.classList.remove('bsm-lock'); burger?.setAttribute('aria-expanded', 'false'); }
  burger?.addEventListener('click', openMnav);
  $('[data-bsm-mnav-close]')?.addEventListener('click', () => { closeMnav(); burger?.focus(); });

  /* ---------- Guide des tailles ---------- */
  const guide = $('#bsm-guide');
  const veil = $('[data-bsm-veil]');
  let guideOpener;
  function openGuide(from) {
    if (!guide) return;
    guideOpener = from;
    guide.classList.add('is-open'); veil?.classList.add('is-open');
    guide.setAttribute('aria-hidden', 'false'); document.body.classList.add('bsm-lock');
    $('[data-bsm-guide-close]', guide)?.focus();
  }
  function closeGuide() {
    if (!guide || !guide.classList.contains('is-open')) return;
    guide.classList.remove('is-open'); veil?.classList.remove('is-open');
    guide.setAttribute('aria-hidden', 'true'); document.body.classList.remove('bsm-lock');
    guideOpener?.focus();
  }
  document.addEventListener('click', (e) => {
    const g = e.target.closest('[data-bsm-guide]');
    if (g) { e.preventDefault(); openGuide(g); }
  });
  $('[data-bsm-guide-close]')?.addEventListener('click', closeGuide);
  veil?.addEventListener('click', closeGuide);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeGuide(); closeMnav(); } });

  /* ---------- Newsletter : « Être prévenu·e » ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-bsm-nl-focus]');
    if (!a) return;
    e.preventDefault();
    const nl = $('#bsm-newsletter');
    nl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => $('#bsm-nl-mail')?.focus({ preventScroll: true }), 450);
  });
  const nlForm = $('#bsm-nl-form');
  nlForm?.addEventListener('submit', (e) => {
    const v = $('#bsm-nl-mail').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      e.preventDefault();
      $('[data-bsm-nl-msg]').textContent = "Cette adresse e-mail n'est pas complète. Vérifie-la et réessaie.";
      $('#bsm-nl-mail').focus();
    }
  });
  if (/customer_posted=true/.test(location.search) && $('#bsm-newsletter')) {
    setTimeout(() => $('#bsm-newsletter').scrollIntoView({ block: 'center' }), 200);
  }


  /* ---------- Étiquette logo : se replie au défilement ---------- */
  const tab = $('[data-bsm-tab]');
  if (tab) {
    const fold = () => tab.classList.toggle('is-folded', window.scrollY > 60);
    window.addEventListener('scroll', fold, { passive: true });
    fold();
  }

  /* ---------- Hero : grand titre à pleine largeur ---------- */
  function fitHero() {
    $$('[data-bsm-fit]').forEach((h) => {
      const sp = h.querySelector('span');
      if (!sp) return;
      h.style.fontSize = '';
      const r = (h.clientWidth * 0.98) / sp.scrollWidth;
      const hero = h.closest('.bsm-hero');
      const cap = hero ? hero.clientHeight * 0.4 : Infinity;
      h.style.fontSize = Math.min(parseFloat(getComputedStyle(h).fontSize) * r, cap) + 'px';
    });
  }
  window.addEventListener('resize', fitHero);
  document.fonts && document.fonts.ready.then(fitHero);
  fitHero();

  /* ---------- Fiche produit ---------- */
  const pdp = $('[data-bsm-pdp]');
  if (pdp) {
    const form = $('[data-bsm-form]', pdp);
    const idInput = $('[data-bsm-variant-id]', pdp);
    const sizes = $('[data-bsm-sizes]', pdp);
    const stock = $('[data-bsm-stock]', pdp);
    const fit = $('[data-bsm-fit-text]', pdp);
    const err = $('[data-bsm-err]', pdp);
    const priceEl = $('[data-bsm-price]', pdp);
    const stickPrice = $('[data-bsm-stick-price]', pdp);
    const addBtn = $('[data-bsm-add-main]', pdp);
    const low = Number(pdp.dataset.low || 3);

    function resetFit() { if (!fit) return; fit.classList.remove('is-err'); fit.textContent = fit.dataset.default || ''; }

    function pick(btn, fromUrl) {
      if (btn.classList.contains('is-out')) {
        stock.textContent = `Le ${btn.dataset.bsmSize} est déjà parti. Il ne reviendra pas.`;
        return;
      }
      $$('[data-bsm-size]', sizes).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      sizes.classList.remove('is-err'); resetFit(); err.textContent = '';
      idInput.value = btn.dataset.variant;
      const q = btn.dataset.qty === '' ? null : Number(btn.dataset.qty);
      stock.textContent = '';
      if (btn.dataset.price) {
        const s = priceEl.querySelector('s');
        priceEl.textContent = btn.dataset.price;
        if (s) priceEl.appendChild(s);
        if (stickPrice) stickPrice.textContent = btn.dataset.price;
      }
      if (!fromUrl) {
        const u = new URL(location.href);
        u.searchParams.set('variant', btn.dataset.variant);
        history.replaceState({}, '', u);
      }
    }

    if (sizes) {
      sizes.addEventListener('click', (e) => { const b = e.target.closest('[data-bsm-size]'); if (b) pick(b); });
      const v = new URL(location.href).searchParams.get('variant');
      const pre = v && $(`[data-variant="${v}"]`, sizes);
      if (pre && !pre.classList.contains('is-out')) pick(pre, true);
      else {
        const avail = $$('[data-bsm-size]:not(.is-out)', sizes);
        if (avail.length === 1) pick(avail[0], true); /* taille unique : présélectionnée */
      }
    }

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!idInput.value) {
        sizes?.classList.add('is-err');
        if (fit) { fit.classList.add('is-err'); fit.textContent = 'Choisis ta taille pour ajouter la pièce.'; }
        sizes?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        $('[data-bsm-size]:not(.is-out)', sizes)?.focus({ preventScroll: true });
        return;
      }
      const r = await addToCart(idInput.value, 1, addBtn);
      err.textContent = r === true ? '' : r;
    });

    /* Barre d'achat mobile */
    const stick = $('[data-bsm-stick]', pdp);
    if (stick && addBtn) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        stick.classList.toggle('is-show', show);
        stick.setAttribute('aria-hidden', String(!show));
        $('[data-bsm-stick-add]', stick).tabIndex = show ? 0 : -1;
      });
      io.observe(addBtn);
      $('[data-bsm-stick-add]', stick).addEventListener('click', () => {
        if (!idInput.value) { addBtn.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        form.requestSubmit ? form.requestSubmit() : addBtn.click();
      });
    }
  }
})();
